"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";
import { Paper, Text, Button, TbArrowLeft, TbSearch } from "@forestsync/ui";

export default function TransactionNotFound() {
  const t = useTranslations();

  return (
    <div className="max-w-2xl mx-auto p-4 md:p-8">
      <Paper withBorder radius="lg" p="xl" className="text-center shadow-md">
        <div className="mb-6">
          <TbSearch
            size={64}
            className="text-gray-400 dark:text-gray-500 mx-auto mb-4"
          />
          <Text size="xl" fw={700} className="mb-2">
            {t("transaction.notFound.title")}
          </Text>
          <Text size="md" className="text-gray-600 dark:text-gray-400">
            {t("transaction.notFound.description")}
          </Text>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            component={Link}
            href="/glassroom"
            leftSection={<TbArrowLeft size={16} />}
            variant="light"
          >
            {t("transaction.notFound.backToGlassroom")}
          </Button>
          <Button
            component={Link}
            href="/glassroom"
            leftSection={<TbSearch size={16} />}
            variant="filled"
          >
            {t("transaction.notFound.exploreTransactions")}
          </Button>
        </div>

        <Text size="sm" className="text-gray-500 dark:text-gray-400 mt-6">
          {t("transaction.notFound.contactSupport")}
        </Text>
      </Paper>
    </div>
  );
}
